var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVehiclesCardHover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "veh\\xEDculos_main",
    "data-name": "veh\\xEDculos main",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 50,
    height: 50,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_30",
    "data-name": "Rect\\xE1ngulo 30",
    width: 44.968,
    height: 44.022,
    fill: "#6e931b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_21",
    "data-name": "Enmascarar grupo 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_30",
    "data-name": "Grupo 30",
    transform: "translate(2.516 3.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_29",
    "data-name": "Grupo 29",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M41.135,18.208v-.07h3.833v-9.9H41.135l0-1.445c0-1.057,0-2.114-.012-3.172A3.51,3.51,0,0,0,37.44.005C27.127,0,17.056,0,7.507.006A3.49,3.49,0,0,0,3.85,3.6c-.006.652,0,1.3,0,1.956v2.7H0v9.9H3.834l.014,13.539q0,.613,0,1.226c0,.83,0,1.659.006,2.488a3.536,3.536,0,0,0,3.659,3.547h.242v.488c0,.694,0,1.366,0,2.038a2.467,2.467,0,0,0,2.553,2.528c.7.008,1.4.012,2.133.012.675,0,1.37,0,2.093-.011a2.506,2.506,0,0,0,2.6-2.544c.01-.584.008-1.168.005-1.752,0-.242,0-.485,0-.727h10.7v.419c0,.653,0,1.3,0,1.938a2.515,2.515,0,0,0,2.716,2.669c1.206.006,2.413,0,3.619,0H34.4a2.515,2.515,0,0,0,2.821-2.742c0-.619,0-1.238,0-1.863v-.447a3.649,3.649,0,0,0,2.7-.916,3.957,3.957,0,0,0,1.223-3.038c-.04-3.989-.028-8.047-.017-11.971q.007-2.415.011-4.829m.037-2.291V10.44c.49,0,.98,0,1.484,0h.057v5.478ZM34.966,39.888c0,.524,0,1.048-.006,1.571-.006.34-.135.341-.284.343-1.374.015-2.778.015-4.29,0-.247,0-.283-.129-.286-.252-.015-.7-.012-1.4-.009-2.135q0-.219,0-.44h4.872ZM14.857,41.61c0,.052-.007.19-.248.192-1.751.012-3.088.012-4.338,0-.16,0-.253-.046-.257-.27-.012-.7-.01-1.393-.007-2.109v-.439H14.87l0,.432c0,.756.009,1.47-.016,2.2M38.865,29.626q0,2.788,0,5.576c0,1.068-.481,1.545-1.559,1.545H7.66c-1.061,0-1.555-.477-1.556-1.5q0-3.712,0-7.425V25.057H38.865ZM6.152,8.558H21.316V22.781H6.152Zm17.5.018H38.833v14.2H23.655Zm13.673-6.37c1.061,0,1.534.467,1.537,1.515q0,.68,0,1.361V6.3H6.108q0-.295,0-.586c-.007-.81-.013-1.575.015-2.35A1.237,1.237,0,0,1,7.347,2.21c.091-.006.182-.006.3,0h5.4q12.144,0,24.286,0M3.8,15.929H2.26V10.477H3.8Z",
    transform: "translate(0 0)",
    fill: "#6e931b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M32.08,94.731h.03a3.7,3.7,0,0,0,3.735-3.6,3.542,3.542,0,0,0-1.069-2.568,3.753,3.753,0,0,0-2.637-1.1h-.024a3.679,3.679,0,0,0-3.7,3.587,3.585,3.585,0,0,0,1.06,2.6,3.7,3.7,0,0,0,2.608,1.079m-1.418-3.618a1.412,1.412,0,0,1,.433-1.025,1.472,1.472,0,0,1,1.034-.42h.012a1.461,1.461,0,0,1,1.022.431,1.4,1.4,0,0,1,.425,1.008,1.462,1.462,0,0,1-1.465,1.427h-.007a1.443,1.443,0,0,1-1.454-1.421",
    transform: "translate(-19.361 -60.224)",
    fill: "#6e931b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M93.05,94.73h.085A3.73,3.73,0,0,0,95.7,93.725a3.575,3.575,0,0,0,1.138-2.557,3.685,3.685,0,0,0-3.651-3.708,3.746,3.746,0,0,0-2.635,1.029A3.582,3.582,0,0,0,89.41,91.06a3.684,3.684,0,0,0,3.64,3.669m.066-2.2a1.434,1.434,0,1,1,.022-2.867h.008a1.451,1.451,0,0,1,1.015.417A1.4,1.4,0,0,1,94.6,91.09h0a1.427,1.427,0,0,1-.442,1.034,1.452,1.452,0,0,1-1.038.41",
    transform: "translate(-60.926 -60.223)",
    fill: "#6e931b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_29",
    "data-name": "Rect\\xE1ngulo 29",
    width: 8.672,
    height: 2.172,
    transform: "translate(18.148 29.797)",
    fill: "#6e931b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehiclesCardHover);
export default __webpack_public_path__ + "static/media/icon_vehicles_card_hover.a30fd8f2984af68ee102054fa0ae9bb8.svg";
export { ForwardRef as ReactComponent };